/**
 * Home page (v2) copy variant registry — same pattern as `src/data/landingPages/variants.js`.
 *
 * Page shell version (legacy vs v2 layout) stays on `?v=` via `HomePageRouter`.
 * Copy / assets for the v2 home template use `?hc=` (home content).
 *
 * Version A (default): all-in-one platform copy (home-b.json)
 * Version B (?hc=b):   discipline/rules-focused copy (default.json)
 *
 * Examples:
 *   /home            → Version A (default)
 *   /home?hc=a       → Version A (explicit)
 *   /home?hc=b       → Version B
 */

export const defaultHomeCopyVariantTag = 'home-b';

/**
 * Maps copy variant tag to a key in `homePageConfigs`.
 * Consumed by ?hc= param directly, or via ?v=a / ?v=b (handled in Home.js).
 */
export const homeCopyVariantRegistry = {
  default: 'home-b',
  'a': 'home-b',     // Version A — all-in-one platform copy
  'b': 'default',    // Version B — discipline/rules-focused copy
  '1': 'home-b',
  '2': 'default',
  'home-b': 'default',
};

/**
 * @param {string | null | undefined} tag - from `?hc=` query param
 * @returns {string} key into `homePageConfigs`
 */
export function resolveHomeCopyVariant(tag) {
  if (!tag || typeof tag !== 'string') {
    return defaultHomeCopyVariantTag;
  }
  const slug = homeCopyVariantRegistry[tag.trim().toLowerCase()];
  return slug || defaultHomeCopyVariantTag;
}
